import ContainerComponent from '../container';

class PanelComponent extends ContainerComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default PanelComponent;
